import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";

const MAX = 500;

const HubMedCommentComposer = ({
  disabled,
  onSubmit,
  submitting,
}) => {
  const [text, setText] = useState("");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    if (!submitting) setLocalError("");
  }, [submitting]);

  const trimmed = text.trim();
  const len = text.length;

  const handleSubmit = async () => {
    setLocalError("");
    if (!trimmed) {
      setLocalError("Enter a note before saving.");
      return;
    }
    if (trimmed.length > MAX) {
      setLocalError(`Notes can be at most ${MAX} characters.`);
      return;
    }
    await onSubmit(trimmed);
    setText("");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <TextField
        multiline
        minRows={3}
        maxRows={8}
        fullWidth
        placeholder="Add an onboarding note…"
        value={text}
        disabled={disabled || submitting}
        onChange={(e) => setText(e.target.value)}
        error={Boolean(localError)}
        helperText={localError || `${len} / ${MAX}`}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={disabled || submitting || !trimmed || trimmed.length > MAX}
          sx={{ textTransform: "none", fontWeight: 600 }}
        >
          {submitting ? "Saving…" : "Add note"}
        </Button>
      </Box>
    </Box>
  );
};

export default HubMedCommentComposer;
